import { render, staticRenderFns } from "./PageActivitiesRestore.vue?vue&type=template&id=d7ff50f6&"
import script from "./PageActivitiesRestore.vue?vue&type=script&lang=js&"
export * from "./PageActivitiesRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports